import React from "react"

import { communityTypes } from "../../../../config/application-definitions"

import BackgroundImage from "../../../common/BackgroundImage"
import ShortTextWithReadMore from "../../../common/ShortTextWithReadMore"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"

const CommunityViewItemDetails = ({
    name,
    description,
    status,
    privacy,
    image_url,
    open_feed,
    isFetching
}) => (
    <div className="widget">
        <div id="community-detail-content" className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-headline" />Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>{name || "No name"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-description" />Description
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={2}
                maxLines={5}
            >
                {description && description !== "" ? (
                    <ShortTextWithReadMore
                        text={description}
                        allowHTML="true"
                        placeholder="No bio"
                    />
                ) : (
                    <p>No description</p>
                )}
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-status" />Status
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>{status || "No status"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-status" />Type
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                lineLength={30}
                minLines={1}
                maxLines={3}
            >
                <p>{(privacy && communityTypes[privacy]) || "No type"}</p>
                {privacy === "inviteonly" && (
                    <div>
                        <h3>
                            <span className="icon icon-article" />Open feed
                        </h3>
                        <p>{open_feed ? "Open" : "Closed"}</p>
                    </div>
                )}
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-heroimg" />Hero image
            </h3>
            <BackgroundImage
                classList={["item-background-image"]}
                imageUrl={image_url}
            />
        </div>
    </div>
)

export default CommunityViewItemDetails
